/* eslint-disable react/prefer-stateless-function */
import React, { Component, Fragment } from 'react';

import { FaPen } from 'react-icons/fa';
import { Item, Table, Footer } from './styles';

class Product extends Component {
  render() {
    const {
      imageUrl,
      name,
      sku,
      price,
      specialPrice,
      quantity,
      visible,
    } = this.props.item;

    return (
      <Fragment>
        <Item specialPrice={specialPrice}>
          <td>
            <div className="img" style={{ backgroundImage: `url(${imageUrl})` }} />
          </td>
          <td style={{ width: '400px', maxWidth: '400px' }}>
            <span>{name}</span>
          </td>
          <td>
            <span>{sku}</span>
          </td>
          <td>
            <span className="price">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price)}</span>
            <span className="special-price">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(specialPrice)}</span>
          </td>
          <td>
            <span className={quantity !== 0 ? '' : 'red'}>
              {quantity !== 0 ? quantity : 'Esgotado'}
            </span>
          </td>
          <td>
            <span className={visible ? '' : 'red'}>
              {visible ? 'Ativado' : 'Desativado'}
            </span>
          </td>
          <td>
            <button type="button" onClick={() => this.props.editMaterial(this.props.item)}>
              <FaPen className="fa fa-pen" />
              {'Editar'}
            </button>
          </td>
        </Item>
        <Table specialPrice={specialPrice}>
          <tr>
            <th>Nome</th>
            <td><span>{name}</span></td>
          </tr>
          <tr>
            <th>Código</th>
            <td><span>{sku}</span></td>
          </tr>
          <tr>
            <th>Preço</th>
            <td>
              <span className="price">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price)}</span>
              <span className="special-price">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(specialPrice)}</span>
            </td>
          </tr>
          <tr>
            <th>Quantidade</th>
            <td>
              <span className={quantity !== 0 ? '' : 'red'}>
                {quantity !== 0 ? quantity : 'Esgotado'}
              </span>
            </td>
          </tr>
          <tr>
            <th>Status</th>
            <td>
              <span className={visible ? '' : 'red'}>
                {visible ? 'Ativado' : 'Desativado'}
              </span>
            </td>
          </tr>
        </Table>
        <Footer>
          <button type="button" onClick={() => this.props.editMaterial(this.props.item)}>
            <FaPen className="fa fa-pen" />
            {'Editar'}
          </button>
        </Footer>
      </Fragment>
    );
  }
}

export default Product;
